module.exports = __webpack_public_path__ + "static/media/dian.b085631b.jpg";